import * as React from 'react'
import { TextSeparatorDot } from '../TextSeparatorDot'

interface Props {
  separator: React.ReactNode
}

export const ElementJoiner: React.FC<Props> = ({ separator = <TextSeparatorDot />, children }) => {
  const visibleChildren = React.Children.map(children, child => child).filter(c => c)

  return (
    <>
      {visibleChildren.map((child, i) => {
        if (i === 0) return child

        return (
          // This is no better than what react does by default, but it cleans up our dev console at least.
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={i}>
            {separator}
            {child}
          </React.Fragment>
        )
      })}
    </>
  )
}
